import { Redirect } from "react-router-dom";
import useAuth from "../../contexts/auth";

export default function Admin() {
  const { user } = useAuth();

  if (user && user.type !== "admin") {
    return <Redirect to="/" />;
  } else {
    return <Redirect to="/admin/dashboard" />;
  }
}
